<!-- <app-header-bar (toggleMenu)="toggleTopMenu($event)"></app-header-bar> -->
<nav class="navbar navbar-dark fixed-top p-0 justify-content-between">
  <div class="align-items-center row no-gutters">
    <button class="btn-toggle d-flex justify-content-center">
      <span (click)="sidebarToggle((isCollapsedMenu = !isCollapsedMenu))">
        <i class="icon-xl d-none d-md-block" [ngClass]="isCollapsedMenu ? 'icon-move-right-1' : 'icon-navigation-drawer'"></i>
        <i class="icon-xl d-block d-md-none" [ngClass]="isCollapsedMenu ? 'icon-navigation-drawer' : 'icon-move-right-1'"></i>
      </span>
    </button>
  </div>
</nav>
<div class="portal-page-container container-fluid">
  <div class="row">
    <app-super-admin-side-menu [isCollapsed]="toggle"></app-super-admin-side-menu>
    <div class="col portal-page">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div class="overlay"></div>
